<template>
  <detailed-list>
    <template slot="list">
      <invoices class="h-full flex flex-col justify-between" ref="invoices" />
    </template>
    <div class="relative h-full">
      <fade-transition>
        <saving-overlay
          opacity="40"
          text-color="text-gray-100"
          v-if="updatingSelected && displayDetail"
        ></saving-overlay>
      </fade-transition>

      <fade-transition mode="out-in">
        <router-view :i18n="i18n" class="h-full" />
      </fade-transition>
    </div>
  </detailed-list>
</template>

<script>
import DetailedList from "../Layout/DetailedList";
import Invoices from "../Billing/Invoices";

export default {
  components: { Invoices, DetailedList },
  computed: {
    selectedInvoice() {
      return this.$store.getters["safe/getSelectedRefill"];
    },

    displayDetail() {
      return this.selectedInvoice !== undefined;
    },

    i18n() {
      return this.$store.state.safe.i18n;
    },

    updatingSelected() {
      return this.$store.state.safe.updatingSelected;
    },
  },
};
</script>
